import { render, staticRenderFns } from "./LiveSDKV1.vue?vue&type=template&id=46177b6c&scoped=true&"
import script from "./LiveSDKV1.vue?vue&type=script&lang=ts&"
export * from "./LiveSDKV1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46177b6c",
  null
  
)

export default component.exports